module.exports = __webpack_public_path__ + "static/img/standard.95f649c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f1/standard.png
// module id = HmgV
// module chunks = 0